/* Royal Bee — Homepage v1: scroll reveal, quick add to cart, reviews slider */
(function () {
  if (window.__rbHome) return; window.__rbHome = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal (uses pdp3-rv styles) ---------- */
  var groups = [
    ['.rbh-head', '', 0],
    ['.rbh-hero__inner > *', '', 120],
    ['.rbh-grid--products .rbh-grid__item', '', 80],
    ['.rbh-tile', '', 100],
    ['.rbh-row__text', 'left', 0],
    ['.rbh-row__media', 'right', 0],
    ['.rbh-reviews .pdp3-h2, .rbh-reviews .pdp3-reviews__sum, .rbh-reviews .pdp3-reviews__wrap', '', 0],
    ['.rbh-insta__feed', '', 0],
    ['.rbh-post', '', 100],
    ['.rbh-foot', '', 0]
  ];
  function reveal(root) {
    var els = [];
    groups.forEach(function (g) {
      (root || document).querySelectorAll(g[0]).forEach(function (el, i) {
        if (el.classList.contains('pdp3-rv')) return;
        el.classList.add('pdp3-rv');
        if (g[1]) el.classList.add('pdp3-rv--' + g[1]);
        if (g[2]) el.style.setProperty('--rv-d', Math.min(i % 4 * g[2], 480) + 'ms');
        els.push(el);
      });
    });
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- quick add to cart (theme cart pop-up / drawer) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rbh-add]'); if (!btn || btn.disabled) return;
    e.preventDefault();
    var span = btn.querySelector('span'), label = span ? span.textContent : '';
    btn.disabled = true; btn.classList.add('is-loading');
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var fd = new FormData(); fd.append('id', btn.dataset.variant); fd.append('quantity', 1);
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map(function (x) { return x.id; }));
      fd.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.disabled = false; btn.classList.remove('is-loading');
      if (res.status) { if (span) span.textContent = res.description || 'Unavailable'; setTimeout(function () { if (span) span.textContent = label; }, 2200); return; }
      if (cart && cart.renderContents) { cart.renderContents(res); cart.classList.remove('is-empty'); }
      else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
      if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'home-v1', productVariantId: btn.dataset.variant, cartData: res });
      btn.classList.add('is-added'); if (span) span.textContent = 'Added ✓';
      setTimeout(function () { btn.classList.remove('is-added'); if (span) span.textContent = label; }, 1800);
    }).catch(function () { btn.disabled = false; btn.classList.remove('is-loading'); if (span) span.textContent = label; });
  });

  /* ---------- reviews slider ---------- */
  function slider(wrap) {
    if (!wrap || wrap.dataset.ready) return; wrap.dataset.ready = '1';
    var track = wrap.querySelector('[data-track]'); if (!track) return;
    var cards = [].slice.call(track.querySelectorAll('.pdp3-review'));
    var dots = [].slice.call(wrap.querySelectorAll('[data-dots] span'));
    if (!cards.length) return;
    var idx = 0, timer;
    function go(i) {
      idx = (i + cards.length) % cards.length;
      var c = cards[idx];
      track.scrollTo({ left: c.offsetLeft - track.offsetLeft - (track.clientWidth - c.clientWidth) / 2, behavior: 'smooth' });
      cards.forEach(function (x, k) { x.classList.toggle('is-active', k === idx); });
      dots.forEach(function (x, k) { x.classList.toggle('is-active', k === idx); });
    }
    function restart() { clearInterval(timer); if (!reduce && cards.length > 1) timer = setInterval(function () { go(idx + 1); }, 5000); }
    wrap.querySelectorAll('.pdp3-arrow').forEach(function (b) { b.addEventListener('click', function () { go(idx + (+b.dataset.dir)); restart(); }); });
    cards.forEach(function (c, k) { c.addEventListener('click', function () { if (k !== idx) { go(k); restart(); } }); });
    track.addEventListener('mouseenter', function () { clearInterval(timer); });
    track.addEventListener('mouseleave', restart);
    var sx = null;
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; clearInterval(timer); }, { passive: true });
    track.addEventListener('touchend', function (e) { if (sx === null) return; var d = e.changedTouches[0].clientX - sx; if (Math.abs(d) > 40) go(idx + (d < 0 ? 1 : -1)); sx = null; restart(); });
    window.addEventListener('resize', function () { go(idx); });
    requestAnimationFrame(function () { go(0); restart(); });
  }

  function init() {
    reveal();
    document.querySelectorAll('[id^="HomeReviews-"]').forEach(slider);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) {
    reveal(e.target);
    e.target.querySelectorAll('[id^="HomeReviews-"]').forEach(slider);
  });
})();
